'use strict';

const LOGIN = 'login';
const SEARCH = 'search';
const SHARE = 'share';
const SIGN_UP = 'sign_up';

const ADD_PAYMENT_INFO = 'add_payment_info';
const ADD_SHIPPING_INFO = 'add_shipping_info';
const ADD_TO_CART = 'add_to_cart';
const ADD_TO_WISHLIST = 'add_to_wishlist';
const BEGIN_CHECKOUT = 'begin_checkout';
const PURCHASE = 'purchase';
const REFUND = 'refund';
const REMOVE_FROM_CART = 'remove_from_cart';
const REMOVE_ALL_FROM_CART = 'remove_all_from_cart';
const SELECT_ITEM = 'select_item';
const SELECT_PROMOTION = 'select_promotion';
const VIEW_CART = 'view_cart';
const VIEW_ITEM = 'view_item';
const VIEW_ITEM_LIST = 'view_item_list';
const VIEW_PROMOTION = 'view_promotion';

export {
    LOGIN,
    SEARCH,
    SHARE,
    SIGN_UP,
    ADD_PAYMENT_INFO,
    ADD_SHIPPING_INFO,
    ADD_TO_CART,
    ADD_TO_WISHLIST,
    BEGIN_CHECKOUT,
    PURCHASE,
    REFUND,
    REMOVE_FROM_CART,
    REMOVE_ALL_FROM_CART,
    SELECT_ITEM,
    SELECT_PROMOTION,
    VIEW_CART,
    VIEW_ITEM,
    VIEW_ITEM_LIST,
    VIEW_PROMOTION
}